import React, { Fragment } from 'react';
import TextField from './TextField';

export default ({ label, value }) => (
  <Fragment>
    <TextField label={label} value={value} />
  </Fragment>
);
